<template>
  <b-card
    class="timesheets-inputs"
    body-class="py-0 flex-column d-flex"
    header-class="bg-transparent border-bottom-0"
    footer-class="bg-transparent border-top-0 py-0"
  >

    <template #header>
      <h4 class="text-primary text-uppercase font-weight-bold text-center">
        {{$t($getConst.pages.timesheet.total_time)}}
      </h4>
    </template>


    <TimesheetTimeInput :unit="unit" is-plaintext label="" :value="stdTotal"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(1)" :unit="unit" is-plaintext :label="overtimeTypes.ot1" :value="ot1Total"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(2)" :unit="unit" is-plaintext :label="overtimeTypes.ot2" :value="ot2Total"/>
    <TimesheetTimeInput v-if="isToDisplayOvertime(3)" :unit="unit" is-plaintext :label="overtimeTypes.ot3" :value="ot3Total"/>
    <div v-if="absenceTotal != null && absenceTotal>0">
      <h4 class="text-primary text-uppercase font-weight-bold text-center">
        {{$t($getConst.pages.timesheet.total_absences)}}
      </h4>
      <TimesheetTimeInput :unit="'day'" is-plaintext label="" :value="absenceTotal"/>
    </div>

    <b-form-group :label="$t($getConst.pages.timesheet.comment)"
                  class="mt-auto" label-class="text-primary" label-for="comment-input">
      <b-form-textarea
        id="comment-input"
        v-model="$v.commentTotal.$model"
        :disabled="isApprover() || timesheet.Status === $getConst.timesheetsStatus.submitted"
        :class="{ 'is-invalid': $v.commentTotal.$error }"
        size="lg"
        @input="updateTimesheetCommentTotal"
      ></b-form-textarea>
      <AppFormFeedback :errors="$v.commentTotal"/>

    </b-form-group>
    <AppFormFileInput
      v-if="timesheetsConfig.has_attachment"
      v-model="files"
      class="mx-auto"
      label="Upload supporting files"
      @input="inputFileRecive"
      :timesheetAttachements="oldAttachments"
      :timesheetForm= "timesheet"
      :multipleFile="true"
      :timesheetsConfig="timesheetsConfig"
    />

    <template #footer v-if="!$store.getters['auth/isLoggedAs']">

      <TimesheetConfirmButtons
        v-if="submitFromForm"
        :timesheet="timesheet"
      />

    </template>

  </b-card>
</template>

<script>
  import TimesheetTimeInput from "./TimesheetTimeInput";
  import AppFormFileInput from "../../../components/common/form/AppFormFileInput";
  import TimesheetConfirmButtons from "./TimesheetConfirmButtons";
  import {maxLength} from "vuelidate/lib/validators";
  import AppFormFeedback from "../../../components/common/form/AppFormFeedback";
  import {getTimesheetsConfig} from "../../../api/timesheet.api";

  export default {
    name: "TimesheetTotalHours",
    components: {TimesheetConfirmButtons, AppFormFileInput, TimesheetTimeInput, AppFormFeedback},
    props: {
      timesheet: null,
      submitFromForm: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        unit: null,
        stdTotal: null,
        ot1Total: null,
        ot2Total: null,
        ot3Total: null,
        commentTotal: null,
        files:[],
        absenceTotal: null,
        oldAttachments: [],
        timesheetsConfig: {
          has_attachment:null
        }
      }
    },
    validations: {
      commentTotal: {maxLength: maxLength(100)},
    },
    methods: {
      updateTimesheetCommentTotal(){
        this.timesheet.Notes = this.commentTotal;
      },
      isToDisplayOvertime(overtimeNb) {
        return this['ot'+overtimeNb+'Total'] !== "0.00" ;
      },
      calculateTotalHours() {
        this.stdTotal = 0;
        this.ot1Total = 0;
        this.ot2Total = 0;
        this.ot3Total = 0;
        this.timesheet.Days.Days.forEach(day => {
          this.stdTotal += +day.std;
          this.ot1Total += +day.ot1;
          this.ot2Total += +day.ot2;
          this.ot3Total += +day.ot3;
        });
        this.stdTotal = this.formatHours(this.stdTotal);
        this.ot1Total = this.formatHours(this.ot1Total);
        this.ot2Total = this.formatHours(this.ot2Total);
        this.ot3Total = this.formatHours(this.ot3Total);
      },
      calculateTotalAbsences(){
        this.absenceTotal = 0;
        this.timesheet.Days.Days.forEach(day => {
          if(day.absence === "1"){
            this.absenceTotal += parseFloat(day.absenceQty);
          }
        });
      },
      formatHours(time) {
        time = time.toString();
        if (!time.includes(".")) {
          time = time + ".00";
        }
        return time;
      },
      inputFileRecive(files){
        this.timesheet['Attachments'] = files;
      },
      getTimesheetConfig() {
        getTimesheetsConfig().then(
                config => {
                    this.timesheetsConfig = config.data;
                }

            )
        }
    },
    watch: {
      timesheet: {
        handler(){
          this.calculateTotalHours();
        },
        deep: true
      }
    },
    created() {
      this.getTimesheetConfig();
      this.overtimeTypes = this.timesheet.Days.Types[0];
      this.unit = this.timesheet.Unit;
      this.commentTotal = this.timesheet.Notes;
      this.calculateTotalHours();
      this.calculateTotalAbsences();
      this.timesheet['LanguageID'] =null;
      if(this.timesheet.Attachments.length>0){
        for(let i =0; i<this.timesheet.Attachments.length; i++){
          if(this.timesheet.Attachments[i][0]){
            this.oldAttachments.push({
              'FileName':this.timesheet.Attachments[i].FileName.split('_')[2],
              'FileBase64':this.timesheet.Attachments[i].FileBase64,
            })
          }else{
            this.oldAttachments.push(this.timesheet.Attachments[i]);
          }
        }
        this.timesheet.Attachments = this.oldAttachments;
        this.files = this.oldAttachments;
      }else{
        this.oldAttachments = [];
      }

      this.$v.$touch();
    }
  }
</script>

<style scoped>

</style>
